module.exports = __webpack_public_path__ + "static/media/icon-plus1.2b9cc92c.svg";